import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmn-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: [ './dropdown.component.scss' ],
})

export class DropdownComponent {
    @Input() public readonly label: string;
    @Input() public readonly hasBorder: boolean;

    public hasHover: boolean;
}
